import React, { useMemo } from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from '@browsing/components';

import HeaderWrapper from '@client/components/header/headerWrapper';
import { useConfig } from '@browsing/config';
import { GuestHeader } from '@pegasus/ui-headers';
import { getSupportedLanguages } from './helpers';

type Props = React.ComponentProps<typeof HeaderWrapper> & { isGuest?: boolean };

const LoadableStaticHeader = loadable(
    () => import(/* webpackChunkName: "static-header" */ './staticHeaderContainer'),
);

const Header = ({ isGuest, ...rest }: Props) => {
    const config = useConfig();
    const supportedLanguages = useMemo(() => getSupportedLanguages(config), [config]);

    return (
        <ErrorBoundary fallbackUI={LoadableStaticHeader} componentName="header">
            {isGuest ? (
                <GuestHeader
                    supportedLanguages={supportedLanguages}
                    isPrive={config.isPriveDomain}
                />
            ) : (
                <HeaderWrapper {...rest} supportedLanguages={supportedLanguages} />
            )}
        </ErrorBoundary>
    );
};

export default Header;
